import createImageUrlBuilder from '@sanity/image-url';

const imageBuilder = createImageUrlBuilder({
  projectId: process.env.projectId || '',
  dataset: process.env.dataset || ''
});

export const urlForImage = (source: any) => {
  if (!source?.asset?._ref) {
    return undefined;
  }

  return imageBuilder?.image(source).auto('format').fit('max');
};

export const useCdn = (url: string) => {
  return url?.replace('cdn.sanity.io', process.env.OUTLET === 'iitv' ? 'i.iranintl.com' : 'i.afintl.com');
};

export function resolveOpenGraphImage(image: any, width = 1200, height = 627) {
  if (!image) return undefined;

  const url = urlForImage(image)?.width(width)?.height(height)?.url();
  if (!url) return undefined;

  return { url: useCdn(url), alt: image?.alt as string, width, height };
}

export function generateImageUrl(image: any, width: number, height: number, quality = 80): string | undefined {
  if (!image) return undefined;

  const url = urlForImage(image)?.width(width)?.height(height)?.auto('format')?.fit('crop').quality(quality)?.url();
  if (!url) return undefined;

  return useCdn(url);
}